import { InfoCircle } from '@aktiia/design-system';
import { useState } from 'react';
import { Popover } from 'react-tiny-popover';

import { DevicesSortBy } from '../../../../../../enums';
import { DevicesSort } from '../devices-sort';
import { PatientInfoPopover } from './components';

export const PatientSort = () => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const handleOnClick = () => {
    setIsPopoverOpen(!isPopoverOpen);
  };

  const handleClose = () => {
    setIsPopoverOpen(false);
  };

  return (
    <div className="flex items-center cursor-pointer">
      <Popover
        align="end"
        reposition={false}
        padding={8}
        isOpen={isPopoverOpen}
        onClickOutside={handleClose}
        positions={['bottom']}
        content={<PatientInfoPopover />}
      >
        <button onClick={handleOnClick}>
          <InfoCircle className="mr-2 scale-75" />
        </button>
      </Popover>
      <DevicesSort by={DevicesSortBy.PATIENT} />
    </div>
  );
};
